import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';


export function ModalWompiButton({ isOpen, messageTitle, showContentAction, ContentAction, title, onHide }) {

    const handleClose = () => {
        onHide();
    };

    return (
        <div>
            <Dialog
                disableEscapeKeyDown={true}
                open={isOpen}
                onClose={onHide}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={'sm'}
                fullWidth={true}
                scroll='body'
                PaperProps={{
                    style: {
                        maxHeight: "90vh",
                    },
                }}
                disableScrollLock={true}
            >
                <DialogTitle style={{ fontWeight: 'bolder', fontFamily: 'GT Walsheim Pro' }} id="alert-dialog-title">
                    {title}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>

                <DialogContent
                    dividers
                    style={{
                        overflowY: "auto",
                        WebkitOverflowScrolling: "touch",
                        maxHeight: "70vh"
                    }}
                >
                    <DialogContentText style={{ color: 'grey', fontFamily: 'GT Walsheim Pro' }} id="alert-dialog-description">
                        {messageTitle}
                    </DialogContentText>

                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        {showContentAction && ContentAction}
                    </div>
                </DialogContent>
            </Dialog>

        </div>
    );
}